import { render } from "./WebentwicklungPage.vue?vue&type=template&id=7b24c037"
import script from "./WebentwicklungPage.vue?vue&type=script&lang=js"
export * from "./WebentwicklungPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__